import { render, staticRenderFns } from "./team-importer-page.vue?vue&type=template&id=f5604166&"
import script from "./team-importer-page.vue?vue&type=script&lang=js&"
export * from "./team-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports